var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMhoDocumentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "12px",
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4 Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Super-Admin-Dashboard-V3",
    transform: "translate(-438.000000, -665.000000)",
    stroke: "#5C76A7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-4",
    transform: "translate(439.000000, 666.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15465121,0.283005081 L7.69707839,0.810364844 C7.89073886,0.998645857 8,1.25725956 8,1.52735976 L8,9 C8,9.55228475 7.55228475,10 7,10 L1,10 C0.44771525,10 6.76353751e-17,9.55228475 0,9 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L6.45757282,0 C6.71791243,6.27493627e-16 6.96798903,0.10152796 7.15465121,0.283005081 Z",
    id: "Path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L6,1.5 C6,1.77614237 6.22385763,2 6.5,2 L8,2 L8,2",
    id: "Path-10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 4.5,
    x2: 6,
    y2: 4.5,
    id: "Path-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 6.5,
    x2: 6,
    y2: 6.5,
    id: "Path-11-Copy"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMhoDocumentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mho-document-icon.1381954810b46968a948bedcceab2da2.svg";